import { render, staticRenderFns } from "./BenifitDetailsWidget.vue?vue&type=template&id=6507faba&scoped=true"
import script from "./BenifitDetailsWidget.vue?vue&type=script&lang=js"
export * from "./BenifitDetailsWidget.vue?vue&type=script&lang=js"
import style0 from "./BenifitDetailsWidget.vue?vue&type=style&index=0&id=6507faba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507faba",
  null
  
)

/* custom blocks */
import block0 from "./BenifitDetailsWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports